import React, { Fragment } from 'react';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

const formInterventionCenter = [
  { key: 'name', label: 'Name' },
  { key: 'postcode', label: 'PLZ' },
  { key: 'address', label: 'Straße, Hausnummer' },
  { key: 'location', label: 'Ort' },
  { key: 'phone', label: 'Telefon' },
  { key: 'mail', label: 'E-Mail' },
  { key: 'fax', label: 'Fax' },
  { key: 'empty', label: '' },
  { key: 'homepage', label: 'Homepage' },
  { key: 'empty2', label: '' },
];

const formHoursPerWeek = [
  { key: 'name_1', label: 'Name' },
  { key: 'hoursPerWeek_1', label: 'Wochenstundenzahl' },
  { key: 'name_2', label: 'Name' },
  { key: 'hoursPerWeek_2', label: 'Wochenstundenzahl' },
  { key: 'name_3', label: 'Name' },
  { key: 'hoursPerWeek_3', label: 'Wochenstundenzahl' },
];

function InterventionCenter() {
  return (
    <>
      <Paper
        elevation={0}
        sx={{
          display: 'block',
          padding: '0px 24px 20px 24px',
          maxWidth: '650px',
          minWidth: '300px',
        }}
      >
        <Stack direction='column'>
          <Grid container>
            <Grid item xs={12}>
              <Typography fontSize='0.9rem' fontWeight='bold'>
                1 Interventionsstelle
              </Typography>
            </Grid>
          </Grid>
          <Grid container columnSpacing={4} className='fhbf-print-field-border'>
            {formInterventionCenter.map((entry, index) => (
              <Fragment key={entry.key}>
                {entry.label.length === 0 ? (
                  <Grid item xs={index % 2 ? 5 : 7} mb={1}></Grid>
                ) : (
                  <Grid item xs={index % 2 ? 5 : 7} mb={1}>
                    <TextField label={entry.label} variant='standard' fullWidth />
                  </Grid>
                )}
              </Fragment>
            ))}
          </Grid>
          <Grid container columnSpacing={4}>
            <Grid item xs={12} mt={2}>
              <Typography fontSize='0.9rem' fontWeight='bold'>
                bei folgendem Frauenhaus/Frauennotruf angegliedert
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField label='Bezeichnung' variant='standard' fullWidth multiline rows={2} />
            </Grid>
            <Grid item xs={12}>
              <Typography fontSize='0.9rem' fontWeight='bold'>
                Zuständig für den Bereich folgender Polizeiinspektionen:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField label='Bezeichnung' variant='standard' fullWidth multiline rows={2} />
            </Grid>
            <Grid item xs={12} mt={2}>
              <Typography fontSize='0.9rem' mb={0}>
                <b>Wochenstundenzahl</b> der jeweils in der Interventionsstelle tätigen Beratungskräfte:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ borderBottomWidth: 3, borderColor: '#000000' }} />
            </Grid>
            <Grid item xs={12}>
              <Typography fontSize='0.75rem'>
                <b>Hinweis:</b> Einzutragen ist die vertraglich festgelegte Arbeitszeit
              </Typography>
            </Grid>
          </Grid>
          <Grid container columnSpacing={4} className='fhbf-print-field-border' mb={1}>
            {formHoursPerWeek.map((entry, index) => (
              <Grid key={entry.key} item xs={index % 2 ? 5 : 7}>
                <TextField label={entry.label} variant='standard' fullWidth className='fhbf-print-field-padding' />
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Paper>
    </>
  );
}

export default InterventionCenter;
